import { useTranslation } from 'react-i18next';
import { Dialog, TextV2 } from '@insights-ltd/design-library/components';
import { Box } from '@mui/material';
import { spacingSizeMap } from '@insights-ltd/design-library/themes';
import Evaluator from 'components/Svgs/ASSET-Evaluator.svg';

export type PurchaseConfirmationDialogProps = {
  open: boolean;
  onClose: () => void;
};

const PurchaseConfirmationDialog = ({
  open,
  onClose,
}: PurchaseConfirmationDialogProps) => {
  const { t } = useTranslation();

  return (
    <Dialog
      onClose={onClose}
      open={open}
      content={
        <Box
          sx={(theme) => ({
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            p: { textAlign: 'center' },
            img: { marginBottom: theme.spacing(spacingSizeMap.S) },
          })}
        >
          <img
            alt={t(
              'ui.event-management.events.purchase-profiles.confirmation-title',
            )}
            src={Evaluator}
          />
          <TextV2 variant="bodyBold" color="textPrimary">
            {t(
              'ui.event-management.events.purchase-profiles.confirmation-sub-title',
            )}
          </TextV2>
          <TextV2 color="textPrimary">
            {t(
              'ui.event-management.events.purchase-profiles.confirmation-content.no-email',
            )}
          </TextV2>
        </Box>
      }
      secondaryButtonText={t(
        'ui.event-management.events.purchase-profiles.confirmation-close-button',
      )}
      title={t(
        'ui.event-management.events.purchase-profiles.confirmation-title',
      )}
    />
  );
};

export default PurchaseConfirmationDialog;
